import { ReactNode } from 'react';

import { Box, useTheme } from '@sbv-clients/ui-shared';

import { LineIcon, LineIconName } from './line-icon';

export const CardHead = ({
  icon,
  label,
  right,
  tone = 'blue',
}: {
  icon: LineIconName;
  label: string;
  right?: ReactNode;
  tone?: 'blue' | 'amber';
}) => {
  const theme = useTheme();
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
      <Box
        sx={{
          width: 28,
          height: 28,
          borderRadius: '8px',
          display: 'grid',
          placeItems: 'center',
          background:
            tone === 'amber'
              ? theme.custom?.messageWarnBg
              : theme.custom?.shellMenuItemCurrentBg,
          color:
            tone === 'amber'
              ? theme.custom?.messageWarnIcon
              : theme.colors.primary.main,
        }}
      >
        <LineIcon name={icon} />
      </Box>
      <Box
        component="h2"
        sx={{
          flex: 1,
          margin: 0,
          fontSize: '13.5px',
          fontWeight: 500,
          color: theme.custom?.headerInfoText,
        }}
      >
        {label}
      </Box>
      {right}
    </Box>
  );
};

export const CardTitle = ({
  title,
  right,
}: {
  title: string;
  right?: ReactNode;
}) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        margin: '-18px -20px 0',
        padding: '16px 20px 14px',
        borderBottom: `1px solid ${theme.custom?.tableTitleDivider}`,
      }}
    >
      <Box
        component="h2"
        sx={{
          flex: 1,
          margin: 0,
          fontSize: '16px',
          fontWeight: 650,
          color: theme.custom?.brandNavy,
        }}
      >
        {title}
      </Box>
      {right}
    </Box>
  );
};
